import Session from "Session";
import $ from "jquery";
import app from "src/shared/app";
import navigation from "src/shared/navigation-v2";
import featureFlagService from "src/shared/feature-flag-service";
import queryStringActionsService from "src/shared/query-string-actions-service";

app.onStart(() => {
    navigation.start();
    queryStringActionsService.addListeners($("#js-sidebar-item-support"));
});
app.start();
